import { render, staticRenderFns } from "./Self-help.vue?vue&type=template&id=e66d2878&scoped=true&"
import script from "./Self-help.vue?vue&type=script&lang=js&"
export * from "./Self-help.vue?vue&type=script&lang=js&"
import style0 from "./Self-help.vue?vue&type=style&index=0&id=e66d2878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66d2878",
  null
  
)

export default component.exports